"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.COLLAPSE_ROOT_CLASS_NAME = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactClickOutside = _interopRequireDefault(require("react-click-outside"));
var _Collapse = _interopRequireDefault(require("./Collapse.style"));
var _excluded = ["children", "classPrefix", "header", "footer", "dataTestId"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var COLLAPSE_ROOT_CLASS_NAME = 'Collapse';
exports.COLLAPSE_ROOT_CLASS_NAME = COLLAPSE_ROOT_CLASS_NAME;
var Collapse = /*#__PURE__*/function (_React$Component) {
  _inherits(Collapse, _React$Component);
  var _super = _createSuper(Collapse);
  function Collapse(props) {
    var _this;
    _classCallCheck(this, Collapse);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "getOpenItems", function () {
      return _this.props.openItems || _this.props.defaultOpen && _this.props.items && _this.props.items.map(function (_, index) {
        return index;
      }) || [];
    });
    _defineProperty(_assertThisInitialized(_this), "collapseAll", function () {
      if (_this.state.openItems.length > 0) {
        _this.setState({
          openItems: []
        });
      }
    });
    // eslint-disable-next-line react/no-unused-class-component-methods
    _defineProperty(_assertThisInitialized(_this), "handleClickOutside", function () {
      var externalCollapse = _this.props.externalCollapse;
      if (externalCollapse) _this.collapseAll();
    });
    _defineProperty(_assertThisInitialized(_this), "toggle", function (index) {
      var openItems = _this.state.openItems;
      var multi = _this.props.multi;
      var closing = openItems.includes(index);
      if (!closing && !multi) {
        return _this.setState({
          openItems: [index]
        });
      }
      return _this.setState({
        openItems: closing ? openItems.filter(function (i) {
          return i !== index;
        }) : [].concat(_toConsumableArray(openItems), [index])
      });
    });
    _this.state = {
      openItems: _this.getOpenItems()
    };
    return _this;
  }
  _createClass(Collapse, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        children = _this$props.children,
        classPrefix = _this$props.classPrefix,
        header = _this$props.header,
        footer = _this$props.footer,
        dataTestId = _this$props.dataTestId,
        otherProps = _objectWithoutProperties(_this$props, _excluded);
      var openItems = this.state.openItems;
      return /*#__PURE__*/_react["default"].createElement(_Collapse["default"], _extends({
        className: classPrefix
      }, otherProps, {
        "data-testid": dataTestId
      }), header && /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(classPrefix, "-header")
      }, header), children && children({
        toggle: this.toggle,
        openItems: openItems,
        classPrefix: classPrefix,
        collapseAll: this.collapseAll
      }), footer && /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(classPrefix, "-footer")
      }, footer));
    }
  }]);
  return Collapse;
}(_react["default"].Component);
Collapse.propTypes = {
  openItems: _propTypes["default"].arrayOf(_propTypes["default"].number),
  children: _propTypes["default"].func.isRequired,
  header: _propTypes["default"].node,
  footer: _propTypes["default"].node,
  /* If the component should collapse when clicking outside it */
  externalCollapse: _propTypes["default"].bool,
  classPrefix: _propTypes["default"].string,
  multi: _propTypes["default"].bool,
  defaultOpen: _propTypes["default"].bool,
  items: _propTypes["default"].arrayOf(_propTypes["default"].shape({})),
  dataTestId: _propTypes["default"].string
};
Collapse.defaultProps = {
  openItems: null,
  header: null,
  footer: null,
  externalCollapse: false,
  classPrefix: COLLAPSE_ROOT_CLASS_NAME,
  multi: true,
  defaultOpen: true,
  items: null,
  dataTestId: 'collapse-wrapper'
};
Collapse.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "getOpenItems",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "collapseAll",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "handleClickOutside",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "toggle",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "index",
      "type": null
    }],
    "returns": null
  }],
  "displayName": "Collapse",
  "props": {
    "openItems": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "number"
        }
      },
      "required": false
    },
    "header": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "node"
      },
      "required": false
    },
    "footer": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "node"
      },
      "required": false
    },
    "externalCollapse": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "classPrefix": {
      "defaultValue": {
        "value": "'Collapse'",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "multi": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "defaultOpen": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "items": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "shape",
          "value": {}
        }
      },
      "required": false
    },
    "dataTestId": {
      "defaultValue": {
        "value": "'collapse-wrapper'",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "children": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    }
  }
};
var _default = (0, _reactClickOutside["default"])(Collapse);
exports["default"] = _default;